import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type { FileRecord } from "../FileRecord";

import { fileQueryKeys } from "./fileQueryKeys";

/**
 * The entries `associationId` holds at any of `relativePaths`, links
 * included, keyed by path, in one request (see `FileService.getFilesAtPaths`).
 * Disabled while `associationId` is undefined or there are no paths to look
 * up.
 */
export function useFilesAtPaths(
  associationId: string | undefined,
  relativePaths: readonly string[],
  resourceOwnerId: string | undefined,
) {
  const { files } = useDomainServices();

  return useQuery<Map<string, FileRecord>, Error>({
    queryKey: fileQueryKeys.atPaths(associationId ?? "", relativePaths),
    queryFn: ({ signal }) => {
      if (associationId === undefined) {
        return Promise.reject(new Error("Invalid associationId"));
      }
      return files.getFilesAtPaths(associationId, [...relativePaths], {
        abortSignal: signal,
        resourceOwnerId,
      });
    },
    enabled: associationId !== undefined && relativePaths.length > 0,
  });
}
